import type { Engine } from '@tsparticles/engine';
import { loadConfettiPreset } from '@tsparticles/preset-confetti';
import Particles, { ParticlesProvider } from '@tsparticles/react';
import { useCallback, useMemo, useState } from 'react';

export default function Confetti() {
	const [isLoaded, setIsLoaded] = useState(false);

	// Must remain stable between renders
	const initializeParticles = useCallback(async (engine: Engine) => {
		await loadConfettiPreset(engine);
	}, []);

	const handleParticlesLoaded = useCallback(() => {
		setIsLoaded(true);
	}, []);

	const customColors = useMemo(() => ['#5053c4', '#b749d1', '#ffd662', '#4ff2d1'], []);

	const options = useMemo(
		() => ({
			preset: 'confetti',
			particles: {
				paint: {
					fill: {
						enable: true,
						color: {
							value: customColors,
						},
					},
				},
			},
			emitters: [25, 50, 75].map((x) => ({
				life: { count: 1, duration: 0.1 },
				rate: { quantity: 80 },
				particles: {
					shape: { type: 'square' },
					move: { direction: 'top' },
					size: { value: { min: 5, max: 10 } },
					life: { count: 1, duration: { value: 10 } },
				},
				position: { x, y: 50 },
			})),
		}),
		[customColors],
	);

	return (
		<ParticlesProvider init={initializeParticles}>
			<div
				style={{
					position: 'absolute',
					inset: 0,
					pointerEvents: 'none',
					opacity: isLoaded ? 1 : 0,
					transition: 'opacity 120ms ease-out',
				}}
			>
				<Particles id="confetti" options={options} particlesLoaded={handleParticlesLoaded} />
			</div>
		</ParticlesProvider>
	);
}
